import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { HostActionView } from '@cloudsign/shared';
import { api } from '../../lib/api';
import { t } from '../../lib/i18n';
import { Alert, Button } from '../../components/ui';
import { getHostAction, hostActionUrl, problemText } from './api';
import { LinkProblem, PageLoading, PublicShell, Section } from './PublicShell';

/** /h/:token. GET shows what the reply will be; the POST (a button press) is the only thing that changes anything. */
export function HostActionPage() {
  const { token = '' } = useParams();
  const qc = useQueryClient();
  const key = ['public-link', 'host', token];
  const q = useQuery({ queryKey: key, queryFn: () => getHostAction(token), retry: false });
  const confirm = useMutation({
    mutationFn: () => api.post(hostActionUrl(token), { body: {}, schema: HostActionView, quiet401: true }),
    onSuccess: (v) => qc.setQueryData(key, v),
  });
  const v = q.data;
  return (
    <PublicShell token={token} {...(v ? { title: t('publicLinks.host.title', { name: v.visitorName }) } : {})}>
      {q.isPending ? (
        <PageLoading />
      ) : q.isError ? (
        <LinkProblem error={q.error} onRetry={() => void q.refetch()} />
      ) : v ? (
        <Section>
          <p className="text-slate-700">{t('publicLinks.host.site', { site: v.siteName })}</p>
          {v.done ? (
            <Alert kind="success">{t('publicLinks.host.done')}</Alert>
          ) : !v.available ? (
            <Alert kind="info">{t('publicLinks.host.unavailable')}</Alert>
          ) : (
            <>
              <p className="text-lg font-medium">{t(`publicLinks.host.action.${v.action}`, { name: v.visitorName })}</p>
              {confirm.isError ? <Alert>{problemText(confirm.error)}</Alert> : null}
              <Button variant="primary" className="w-full" disabled={confirm.isPending} onClick={() => confirm.mutate()}>
                {t('publicLinks.host.confirm')}
              </Button>
            </>
          )}
        </Section>
      ) : null}
    </PublicShell>
  );
}
